// extracted by mini-css-extract-plugin
export var accordion = "Accordion-module--accordion--2gosW";
export var bxTextTruncateEnd = "Accordion-module--bx--text-truncate--end--ueZ_7";
export var bxTextTruncateFront = "Accordion-module--bx--text-truncate--front--33xTq";